import axios from "axios";
import Swal from "sweetalert2";
import { getErrorMessage } from "../../utils/errorUtils";
import {
  ADMIN_LOGIN_REQUEST,
  ADMIN_LOGIN_FAIL,
  ADMIN_LOGIN_SUCCESS,
  ADMIN_LOGOUT,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_FAIL,
  FORGOT_PASSWORD_SUCCESS,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAIL,
  USER_VIEW_SUCCESS,
  USER_VIEW_REQUEST,
  USER_VIEW_FAIL,
  VIEW_ACCREDITED_INVESTORS,
  VIEW_ACCREDITED_INVESTORS_FAIL,
  VIEW_ACCREDITED_INVESTORS_SUCCESS,
  VIEW_COUNTRY_DETAILS,
  VIEW_COUNTRY_DETAILS_FAIL,
  VIEW_COUNTRY_DETAILS_SUCCESS,
  SAVE_CURRENCY_DETAILS,
  SAVE_CURRENCY_DETAILS_FAIL,
  SAVE_CURRENCY_DETAILS_SUCCESS,
  USER_VIEW_INVESTMENT_SUCCESS,
  USER_VIEW_INVESTMENT_REQUEST,
  USER_VIEW_INVESTMENT_FAIL,
  VIEW_FOLLOWER_REPORT_SUCCESS,
  VIEW_FOLLOWER_REPORT_REQUEST,
  VIEW_FOLLOWER_REPORT_FAIL,
} from "../constants/adminConstants";

export const login = (email, password, navigate) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_LOGIN_REQUEST });
    const config = {
      headers: {
        "Content-type": "application/json",
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "login-admin",
      { email, password },
      config
    );
    dispatch({ type: ADMIN_LOGIN_SUCCESS, payload: data });
    if (data.staus == 200) {
      localStorage.setItem("admin", JSON.stringify(data));
      localStorage.setItem("accessToken", data.data.accessToken);
      Swal.fire({
        title: data.message,
        timer: 2500,
        timerProgressBar: true,
        icon: "success",
        confirmButtonText: "OK",
        showCloseButton: true,
      });
      navigate("/");
    }
  } catch (error) {
    const errorMessage = getErrorMessage(error, "Wrong email and password");
    Swal.fire({
      title: "Wrong email and password",
      text: errorMessage,
      timer: 2500,
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });

    dispatch({
      type: ADMIN_LOGIN_FAIL,
      payload: errorMessage,
    });
  }
};

export const logout = (navigate) => async (dispatch) => {
  localStorage.removeItem("accessToken");
  dispatch({ type: ADMIN_LOGOUT });
  navigate("/login");
};

export const forgot_password = (email, clear) => async (dispatch) => {
  try {
    dispatch({ type: FORGOT_PASSWORD_REQUEST });
    const config = {
      headers: {
        "Content-type": "application/json",
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "forgot-password",
      { email },
      config
    );
    dispatch({ type: FORGOT_PASSWORD_SUCCESS, payload: data });

    if (data.status == 200) {
      Swal.fire({
        title: data.message,
        timer: 6500,
        timerProgressBar: true,
        icon: "success",
        confirmButtonText: "OK",
        showCloseButton: true,
      });
      clear();
    }
  } catch (error) {
    const errorMessage = getErrorMessage(error, "Failed to send reset link");
    dispatch({
      type: FORGOT_PASSWORD_FAIL,
      payload: errorMessage,
    });
  }
};

export const reset_password =
  (token, newPassword, clear, redirect) => async (dispatch) => {
    try {
      dispatch({ type: RESET_PASSWORD_REQUEST });
      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };
      const { data } = await axios.post(
        process.env.REACT_APP_API + "set-password",
        { token, newPassword },
        config
      );
      dispatch({ type: RESET_PASSWORD_SUCCESS, payload: data });
      if (data.status === 200) {
        Swal.fire({
          title: data.message,
          timer: 6500,
          timerProgressBar: true,
          icon: "success",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
        redirect();
        clear();
      }
    } catch (error) {
      const errorMessage = getErrorMessage(error, "Failed to reset password");
      Swal.fire({
        title: errorMessage,
        timer: 2500,
        timerProgressBar: true,
        icon: "error",
        confirmButtonColor: "#f27474",
        confirmButtonText: "OK",
        dangerMode: true,
        showCloseButton: true,
      });
      redirect();
      dispatch({
        type: RESET_PASSWORD_FAIL,
        payload: errorMessage,
      });
    }
  };

export const getUserDetails = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: USER_VIEW_REQUEST });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "get-user-details-byid",
      { user_id: id.userId },
      config
    );
    dispatch({ type: USER_VIEW_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = getErrorMessage(error, "Failed to load user details");
    Swal.fire({
      title: errorMessage,
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
    dispatch({
      type: USER_VIEW_FAIL,
      payload: errorMessage,
    });
  }
};

export const getAccreditedInvestorsDetails =
  (token, id) => async (dispatch) => {
    try {
      dispatch({ type: VIEW_ACCREDITED_INVESTORS });
      const config = {
        headers: {
          "x-access-token": token,
        },
      };
      const { data } = await axios.post(
        process.env.REACT_APP_API + "get-accrediteduserdetail-byid",
        { id: id.userId },
        config
      );
      dispatch({ type: VIEW_ACCREDITED_INVESTORS_SUCCESS, payload: data });
    } catch (error) {
      const errorMessage = getErrorMessage(error, "Failed to load investor details");
      Swal.fire({
        title: errorMessage,
        timerProgressBar: true,
        icon: "error",
        confirmButtonText: "OK",
        showCloseButton: true,
      });
      dispatch({
        type: VIEW_ACCREDITED_INVESTORS_FAIL,
        payload: errorMessage,
      });
    }
  };

//get-country-list
export const getCountryList = (token) => async (dispatch) => {
  try {
    dispatch({ type: VIEW_COUNTRY_DETAILS });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    const { data } = await axios.get(
      process.env.REACT_APP_API + "get-country",
      config
    );
    dispatch({ type: VIEW_COUNTRY_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = getErrorMessage(error, "Failed to load countries");
    Swal.fire({
      title: errorMessage,
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
    dispatch({
      type: VIEW_COUNTRY_DETAILS_FAIL,
      payload: errorMessage,
    });
  }
};

//managecurrency-rates
export const SaveCurrency = (token, cdata) => async (dispatch) => {
  try {
    dispatch({ type: SAVE_CURRENCY_DETAILS });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "managecurrency-rates-get",
      { page: cdata.page, limit: cdata.limit },
      config
    );
    dispatch({ type: SAVE_CURRENCY_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = getErrorMessage(error, "Failed to load currencies");
    Swal.fire({
      title: errorMessage,
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
    dispatch({
      type: SAVE_CURRENCY_DETAILS_FAIL,
      payload: errorMessage,
    });
  }
};

//get-investment-details
export const getUserInvestmentDetails = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: USER_VIEW_INVESTMENT_REQUEST });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "admin/get-user-campaign-investment",
      { user_id: id.reportId },
      config
    );
    dispatch({ type: USER_VIEW_INVESTMENT_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = getErrorMessage(error, "Failed to load investments");
    Swal.fire({
      title: errorMessage,
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
    dispatch({
      type: USER_VIEW_INVESTMENT_FAIL,
      payload: errorMessage,
    });
  }
};

//get-designation-report-details
export const getFollowersDetails = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: VIEW_FOLLOWER_REPORT_REQUEST });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "getFollowersByManagerId",
      { user_id: id.reportId },
      config
    );
    dispatch({ type: VIEW_FOLLOWER_REPORT_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = getErrorMessage(error, "Failed to load followers");
    Swal.fire({
      title: errorMessage,
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
    dispatch({
      type: VIEW_FOLLOWER_REPORT_FAIL,
      payload: errorMessage,
    });
  }
};
